/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type SidebarSecondaryDirectiveFactoryCb = ($rootScope: ng.IRootScopeService,
                                                       $window: ng.IWindowService,
                                                       $timeout: ng.ITimeoutService) => SidebarSecondaryDirective;

    interface IMyEvent extends Event {
        which?: number;
    }

    export class SidebarSecondaryDirective implements ng.IDirective {
        public static $name: string = 'sidebarSecondary';

        public link: ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'A';

        /**
         * Factory for the directive
         */
        public static Factory(): SidebarSecondaryDirectiveFactoryCb {
            let directive: SidebarSecondaryDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                                 $window: ng.IWindowService,
                                                                 $timeout: ng.ITimeoutService) => {
                return new SidebarSecondaryDirective($rootScope, $window, $timeout);
            };
            directive.$inject = ['$rootScope', '$window', '$timeout'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($rootScope: IFlexRootScope,
                    $window: ng.IWindowService,
                    $timeout: ng.ITimeoutService) {

            SidebarSecondaryDirective.prototype.link = ($scope: ng.IScope,
                                                        $element: JQuery,
                                                        attrs: ng.IAttributes) => {
                let $sidebarSecondary: JQuery = $($element);
                let sidebarSecondarys: JQuery = $('.md-list.SidebarSecondarys');

                // chat
                if ($sidebarSecondary.find('.md-list.chat_users').length) {
                    sidebarSecondarys.on('click', 'li', () => {
                        $('.md-list.SidebarSecondaryusers').velocity("transition.slideRightBigOut", {
                            duration: 280, // sidebarPrimaryToggle
                            easing: [0.4, 0, 1, 1],
                            complete: () => {
                                $sidebarSecondary
                                    .find('.chat_box_wrapper')
                                    .addClass('chat_box_active')
                                    .velocity("transition.slideRightBigIn", {
                                        duration: 280,
                                        easing: [0.4, 0, 1, 1],
                                        begin: () => {
                                            $sidebarSecondary.addClass('chat_sidebar');
                                        },
                                    });
                            },
                        });
                    });

                    $sidebarSecondary
                        .find('.chat_sidebar_close')
                        .on('click', () => {
                            $sidebarSecondary
                                .find('.chat_box_wrapper')
                                .removeClass('chat_box_active')
                                .velocity("transition.slideRightBigOut", {
                                    duration: 280,
                                    easing: [0.4, 0, 1, 1],
                                    complete: () => {
                                        $sidebarSecondary.removeClass('chat_sidebar');
                                        $('.md-list.chat_users').velocity("transition.slideRightBigIn", {
                                            duration: 280,
                                            easing: [0.4, 0, 1, 1],
                                        });
                                    },
                                });
                            });

                    if ($sidebarSecondary.find('.uk-tab').length) {
                        $sidebarSecondary.find('.uk-tab').on('change.uk.tab',
                            (event: JQueryEventObject, activeItem: JQuery, previousItem: JQuery) => {
                                if ($(activeItem).hasClass('chat_sidebar_tab') &&
                                    $sidebarSecondary.find('.chat_box_wrapper').hasClass('chat_box_active')) {
                                    $sidebarSecondary.addClass('chat_sidebar');
                                } else {
                                    $sidebarSecondary.removeClass('chat_sidebar');
                                }
                            });
                    }
                }

                $scope.$on('$destroy', () => {
                    if (sidebarSecondarys.length)
                        sidebarSecondarys.off('click');

                    if ($sidebarSecondary.find('.chat_sidebar_close').length)
                        $sidebarSecondary.find('.chat_sidebar_close').off('change.uk.tab');
                });
            };
        }
    }
}